import id from '@/locales/id.json';

const DICTIONARIES = {
  id,
};

let currentLanguage = 'en';
let subscribed = false;

// Lazily requires the store instead of importing it at module scope, since
// translate() is reachable from low-level modules (e.g. helpers.js) that
// the store itself depends on transitively — a top-level import here would
// create a circular require that crashes the bundle at load time.
const ensureSubscribed = () => {
  if (subscribed) {
    return;
  }
  subscribed = true;

  // eslint-disable-next-line global-require
  const store = require('@/store').default;
  currentLanguage = store.getState().language.selected;
  store.subscribe(() => {
    currentLanguage = store.getState().language.selected;
  });
};

export const translate = (text) => {
  ensureSubscribed();

  if (typeof text !== 'string' || !text) {
    return text;
  }

  const dictionary = DICTIONARIES[currentLanguage];
  if (!dictionary) {
    return text;
  }

  return dictionary[text] || text;
};

export default translate;
